import { render, staticRenderFns } from "./WhatsappIntegrationList.vue?vue&type=template&id=6621eb19&scoped=true"
import script from "./WhatsappIntegrationList.vue?vue&type=script&lang=js"
export * from "./WhatsappIntegrationList.vue?vue&type=script&lang=js"
import style0 from "./WhatsappIntegrationList.vue?vue&type=style&index=0&id=6621eb19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621eb19",
  null
  
)

export default component.exports